import { defineStore } from 'pinia';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { OfferLib } from '@om-retail/offerlib';
// eslint-disable-next-line import/extensions, import/no-unresolved
import { toReactive } from '@om-retail/web-cmp';
import store from '../index';

dayjs.extend(utc);
// eslint-disable-next-line import/prefer-default-export
export const useOfferStore = defineStore('offer', {
    offerInstance: null,
    state: () => ({
        offerLoading: true,
        offerInitialized: false,
        startDate: dayjs().utc().format('YYYY-MM-DD HH:mm:ss'),
        endDate: dayjs().utc().add(1, 'd').format('YYYY-MM-DD HH:mm:ss'),
        selectedVhorseRace: null,
        lottoOfferInitialized: false,
        horseOfferInitialized: false,
        betradarMatchId: null,
        omSession: null,
        clearFavs: false,
    }),
    actions: {
        getOfferInstance()
        {
            return this.offerInstance;
        },
        async initOffer()
        {
            try
            {
                this.offerInitialized = false;
                this.offerInstance = new OfferLib({
                    offerUrl: store.getters.globals.publicConfig.offerServerUrl,
                    langCode: store.getters.globals.langCode,
                    version: store.getters.globals.publicConfig.offerServerVersion,
                    useSse: store.getters.globals.publicConfig.useSse,
                    timeout: 100000,
                });

                this.offerInstance = toReactive(this.offerInstance);
                this.offerInitialized = true;
            }
            catch (e)
            {
                console.error(e);
            }
        },
        destroyOffer()
        {
            this.offerInstance.destroy();
            this.offerInstance = null;
            this.offerInitialized = false;
        },
        async initVHorseOffer()
        {
            try
            {
                this.offerLoading = true;

                await this.offerInstance.vhorse.create({
                    startDate: this.startDate,
                    endDate: this.endDate,
                    raceDefinitionId: store.getters.globals.publicConfig.vhorse.raceDefId,
                });
                this.offerLoading = false;
                this.horseOfferInitialized = true;
            }
            catch (e)
            {
                // e
            }
            finally
            {
                this.offerLoading = false;
            }
        },
        async initLottoOffer()
        {
            try
            {
                await this.offerInstance.lotto.create({ fetchFirstOffer: false });
                this.lottoOfferInitialized = true;
            }
            catch (e)
            {
                // console.log(e);
            }
        },
        async fetchLottoOffer(fetchData)
        {
            try
            {
                await this.offerInstance.lotto.getLottos(
                    {
                        lottoId: fetchData.lottoId,
                        startDate: fetchData.startDate || this.startDate,
                        endDate: fetchData.endDate || this.endDate,
                        limit: fetchData.lottoData,
                    },
                );
            }
            catch (e)
            {
                // e
            }
        },
        destroyVHorseOffer()
        {
            if (!this.offerInstance)
            {
                return;
            }
            if (!this.offerInstance.vhorse)
            {
                return;
            }
            if (!this.horseOfferInitialized)
            {
                return;
            }

            this.horseOfferInitialized = false;
            this.offerInstance.vhorse.destroy();
        },
        destroyLottoOffer()
        {
            if (!this.offerInstance)
            {
                return;
            }
            if (!this.offerInstance.lotto)
            {
                return;
            }
            if (!this.lottoOfferInitialized)
            {
                return;
            }

            this.lottoOfferInitialized = false;
            this.offerInstance.lotto.destroy();
        },
    },
});
